// extracted by mini-css-extract-plugin
export default {"card":"burger-constructor-card_card__s7uoM","card_topping":"burger-constructor-card_card_topping__PHdz7"};